import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=27821a33&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
import style0 from "./Shop.vue?vue&type=style&index=0&id=27821a33&prod&lang=scss&scoped=true"
import style1 from "./Shop.vue?vue&type=style&index=1&id=27821a33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27821a33",
  null
  
)

export default component.exports